namespace Solovis.UI.Buttons {

    /**
     * options:
     * 
     * width: width of the button
     * text: text for the button
     * element: jquery element to append to the button
     * prependElement: if true, will prepend the element instead of appending it
     * links: array of objects compatible with Solovis.UI.PopupLinkPanel
     * cssRules: array of objects of type
     *   {
     *       rule,
     *       value
     *   }
     * size: "small", "large", or "default"
     * 
     */
    export class DropdownButton {

        public _links;
        public _text;
        public _width;
        public _element;
        public _prependElement;
        public _cssRules;
        public _size;
        public _offsetRight;
        public _fromRightEdge;
        public _html;

        public _tooltipOptions;
        public _dropdownButton;
        public _popupLinkPanel;
        public _dropdownButtonGroup;


        constructor(options) {
            this._links = options.links ? options.links : null;
            this._text = options.text ? options.text : null;
            this._width = options.width ? options.width : null;
            this._element = options.element ? options.element : null;
            this._prependElement = options.prependElement ? options.prependElement : null;
            this._cssRules = options.cssRules ? options.cssRules : null;
            this._size = options.size ? options.size : null;
            this._offsetRight = options.offsetRight ? options.offsetRight : null;
            this._fromRightEdge = options.fromRightEdge ? options.fromRightEdge : null;

            if (!this._text && !this._element && !this._html) {
                console.log("Solovis.UI.Buttons.DropdownButton: No text/element/html is provided.");
            }

            this._create();
        }




        public _create() {
            var self = this;

            this._dropdownButton = $("<button>")
                .addClass("btn btn-primary")
                .click(function () {
                    self._dropdownButtonClickHandler();
                });

            switch (this._size) {
                case "small":
                    this._dropdownButton.addClass("btn-xs");
                    break;
                case "large":
                    this._dropdownButton.addClass("btn-lg");
                    break;
                default:
                    this._dropdownButton.addClass("btn-solovisdefault");
                    break;
            }

            if (Solovis.isNotNull(this._width)) {
                if ($.isNumeric(this._width)) {
                    this._dropdownButton.width(this._width);
                }
                else if (this._width.indexOf("%") !== -1 ||
                    this._width.indexOf("px") !== -1 ||
                    this._width.indexOf("em") !== -1) {
                    this._dropdownButton.css("width", this._width);
                }
            }

            if (this._text) {
                this._dropdownButton.text(this._text);
            }

            if (this._element) {
                if (this._prependElement) {
                    this._element
                        .prependTo(this._dropdownButton);
                }
                else {
                    this._element
                        .appendTo(this._dropdownButton);
                }
            }

            if (this._tooltipOptions) {
                this._dropdownButton.solovisTooltip(this._tooltipOptions);
            }

            $("<span>")
                .addClass("caret")
                .css("margin-left", "5px")
                .appendTo(this._dropdownButton);

            if (this._cssRules) {
                Solovis.UI.DomHelper.applyCssRules(this._dropdownButtonGroup, this._cssRules);
            }
        }

        public _dropdownButtonClickHandler() {
            var self = this;
            if (!this._popupLinkPanel) {

                this._dropdownButton
                    .addClass("active")
                    .css("border-bottom-left-radius", "0")
                    .css("border-bottom-right-radius", "0");

                this._popupLinkPanel = Solovis.UI.PopupLinkPanel.showLinks({
                    links: this._links,
                    close: function () {
                        self._dropdownButton
                            .removeClass("active")
                            .css("border-bottom-left-radius", "3px")
                            .css("border-bottom-right-radius", "3px");

                        self._popupLinkPanel = null;
                    },
                    offsetElement: this._dropdownButton,
                    offsetBottom: true,
                    fromRightEdge: this._fromRightEdge,
                    offsetRight: this._offsetRight
                });
            }
        }

        public getElement() {
            return this._dropdownButton;
        }
    }

}